<!-- begin:: Brand -->
<div class="kt-header__brand kt-grid__item" [ngClass]="htmlClassService.getClasses('brand', true)" id="kt_header_brand">
	<div class="kt-header__brand-logo">
		<a href="javascript:;" routerLink="/overall/1">
			<img alt="logo" src="assets/images/logo.png" class="kt-header__brand-logo-default" />
			<img alt="logo" src="assets/images/logo.png" class="kt-header__brand-logo-sticky" />
		</a>
</div>

<!-- end:: Brand -->